/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiAuthor } from "@/types/strapi";

import { BorderRadiuses } from "@/tokens/border";
import { Spacing } from "@/tokens/spacing";

import { Picture } from "./picture";
import { Text } from "./text";

interface TerminusAuthorChipProps {
    author: StrapiAuthor;
    className?: SerializedStyles;
    showCompanyAndRole?: boolean;
}

export const TerminusAuthorChip: FunctionComponent<TerminusAuthorChipProps> = (
    props,
) => {
    const { author, showCompanyAndRole } = props;

    /**
     * Styles
     */
    const terminusAuthorBylineStyles = css(
        {
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            gap: Spacing["spacing-2"],
        },
        props.className,
    );

    const terminusAuthorAvatarStyles = css({
        borderRadius: BorderRadiuses.borderRound,
        width: Spacing["spacing-8"],
    });

    const terminusAuthorNameStyles = css({
        display: "flex",
        flexDirection: "column",
        gap: Spacing["spacing-half"],
    });

    /**
     * Rendering
     */
    const getCompanyAndRoleListString = () => {
        const existingRoleAndCompany = [author.Role, author.Company].filter(
            (value) => typeof value === "string",
        ) as string[];
        return new Intl.ListFormat("en-us", {
            style: "narrow",
        }).format(existingRoleAndCompany);
    };

    return (
        <div css={terminusAuthorBylineStyles}>
            {author.Avatar && (
                <Picture
                    {...author.Avatar}
                    alternativeText={author.Name}
                    className={terminusAuthorAvatarStyles}
                />
            )}

            <div css={terminusAuthorNameStyles}>
                <Text fontSize="TextSmall" themeKey="textPrimary">
                    {author.Name}
                </Text>

                {showCompanyAndRole && (
                    <Text fontSize="TextSmall" themeKey="textPrimary">
                        {getCompanyAndRoleListString()}
                    </Text>
                )}
            </div>
        </div>
    );
};
